import { render, staticRenderFns } from "./MonthlyEISSocso.vue?vue&type=template&id=5b5aae66&scoped=true"
import script from "./MonthlyEISSocso.vue?vue&type=script&lang=js"
export * from "./MonthlyEISSocso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5aae66",
  null
  
)

export default component.exports